<template>
  <div v-if="bookingInvoiceData && bookingInvoiceData.id">
    <div class="ibox-content" style="padding: 16px" v-if="bookingInvoiceData">
      <p class="font-size-18 bold">
        <span class="select-services-dropdown-title"> Invoice & Payment </span>
        <span style="cursor: pointer">
          <span class="float-right">
            <div class="btn-group pair_btn_new_uniq">
              <button
                data-toggle="dropdown"
                data-too="tooltip"
                data-placement="bottom"
                aria-haspopup="true"
                aria-expanded="false"
                class="btn btn-default dropdown-toggle create-btn FontSize"
              >
                <i
                  class="fa fa-ellipsis-v"
                  style="color: rgba(138, 138, 138, 1); font-size: 18px"
                ></i>
              </button>
              <payment-actions-dropdown
                @invoiceTypeChanged="handleInvoiceTypeChange"
                @statusColorChanged="handleStatusColorTypeChange"
                :payment-details="paymentDetails"
                :logged-user="loggedUser"
                :can-see-customer="canSeeCustomer"

                :booking-invoice="bookingInvoiceData"
                :booking-payment-summary="bookingPaymentSummaryData"
                :apply-discount-and-close-invoice="applyDiscountAndCloseInvoice"
                from="mainComponent"
                :company-has-default-payment-gateway="
                  companyHasDefaultPaymentGateway
                "
              >
              </payment-actions-dropdown>
            </div>
          </span>
        </span>
      </p>

      <div :class="{ 'payment-details-container': true, 'm-top-12': 0 > 0 }">
        <div class="row m-right-0 m-left-0">
          <p class="bold">
            <span
              :id="`vue_invoice_num_view_${get_invoice_num_or_merged_invoice_num}`"
              v-if="bookingInvoiceData"
              data-toggle="modal"
              data-target="#popupi"
              @click="
                Invoice_Preview_Data(bookingInvoiceData.id, MergedInvoiceId)
              "
            >
              <label>{{
                MergedInvoiceId
                  ? bookingInvoiceData.merged_invoice_num
                  : bookingInvoiceData.invoice_num
              }}</label>
            </span>

            <span
              :id="`vue_invoice_num_show_action_btn_${get_invoice_num_or_merged_invoice_num}`"
            >
              <a
                @click="
                  show_inputs(
                    'vue_invoice_num',
                    get_invoice_num_or_merged_invoice_num
                  )
                "
                class="icon-position"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z"
                    fill="#2E4051"
                  />
                </svg>
              </a>
            </span>

            <span
              :id="`vue_invoice_num_input_section_${get_invoice_num_or_merged_invoice_num}`"
              class="hidden"
            >
              <input
                type="text"
                class="text-input width-100px"
                :value="
                  MergedInvoiceId
                    ? bookingInvoiceData.merged_invoice_num
                    : bookingInvoiceData.invoice_num
                "
                :id="`vue_invoice_num_input_${bookingInvoiceData.id}`"
              />
              <button
                class="btn save-btn btns-change-data"
                @click="saveInvoiceNum(bookingInvoiceData.id)"
              >
                <i class="fa fa-check"></i>
              </button>
              <button
                @click="
                  hide_inputs(
                    `vue_invoice_num`,
                    get_invoice_num_or_merged_invoice_num
                  )
                "
                class="btn cancel-btn btns-change-data"
              >
                <i class="fa fa-remove"></i>
              </button>
            </span>

            <span
              :class="{
                'status-label labels-font font-family-Roboto m-right-5 cursor-pointer': true,
                'line-height-36':
                  MergedInvoiceId &&
                  bookingInvoiceData.invoice_labels.length > 0,
              }"
              :style="color"
              v-if="bookingInvoiceData"
              data-toggle="modal"
              data-target="#popupi"
              @click="
                Invoice_Preview_Data(bookingInvoiceData.id, MergedInvoiceId)
              "
            >
              {{ bookingInvoiceData.invoice_type }}
            </span>

            <span
              v-if="bookingInvoiceData.email_sent"
              :class="{
                'status-label labels-font font-family-Roboto': true,
                'line-height-36':
                  MergedInvoiceId &&
                  bookingInvoiceData.invoice_labels.length > 0,
              }"
              style="background-color: #0cb225"
            >
              sent
            </span>

            <span
              v-if="MergedInvoiceId"
              data-toggle="modal"
              :data-target="`#invoice-popup${bookingId}`"
              :class="{
                'status-label labels-font font-family-Roboto blue-color m-right-5 cursor-pointer': true,
                'line-height-36':
                  MergedInvoiceId &&
                  bookingInvoiceData.invoice_labels.length > 0,
              }"
              title="show more..."
            >
              Merged invoices
              <i class="fa fa-chevron-right"></i>
            </span>

            <span
              v-if="MergedInvoiceId && bookingInvoiceData.is_locked"
              :class="{
                'status-label labels-font font-family-Roboto green-color m-right-5': true,
                'line-height-36':
                  MergedInvoiceId &&
                  bookingInvoiceData.invoice_labels.length > 0,
              }"
            >
              Locked
            </span>

            <span
              v-if="MergedInvoiceId && !bookingInvoiceData.is_locked"
              :class="{
                'status-label labels-font font-family-Roboto red-color m-right-5': true,
                'line-height-36':
                  MergedInvoiceId &&
                  bookingInvoiceData.invoice_labels.length > 0,
              }"
            >
              Unlocked
            </span>

            <span
              v-if="
                MergedInvoiceId &&
                !bookingInvoiceData.is_locked &&
                bookingInvoiceData.cycle_name
              "
              :class="{
                'status-label labels-font font-family-Roboto blue-color m-right-5': true,
                'line-height-36':
                  MergedInvoiceId &&
                  bookingInvoiceData.invoice_labels.length > 0,
              }"
            >
              {{ bookingInvoiceData.cycle_name }}
            </span>

            <i
              v-if="itemType != 'estimate'"
              ref="toggleIcon"
              class="data_style_filde fa fa-chevron-down rotate float-right cursor-pointer"
              @click="toggleCollapse"
            ></i>

            <span
              v-if="bookingInvoiceData.invoice_labels.length > 0"
              v-for="invoiceLabels in bookingInvoiceData.invoice_labels"
            >
              <span
                v-for="(invoiceLabel, index) in invoiceLabels"
                class="status-label labels-font font-family-Roboto m-right-5 white-space-nowrap cursor-pointer"
                :style="{
                  'background-color':
                    invoiceLabels[index].label_color != null
                      ? invoiceLabels[index].label_color
                      : '#008CFA !important',
                  'white-space': 'nowrap',
                  display: 'inline-flex',
                  'max-width': '100%',
                  overflow: 'hidden',
                  'text-overflow': 'ellipsis',
                  'box-sizing': 'border-box',
                  'margin-bottom': '4px',
                }"
                data-toggle="modal"
                data-target="#popupi"
                @click="Invoice_Add_Label"
              >
                {{ invoiceLabels[index].label_name }}
              </span>
            </span>
          </p>
        </div>

        <div class="p-right-0 p-left-0 col-md-12">
          <div
            class="col-md-12 p-right-0 p-left-0 labels-font font-family-Roboto"
          >
            Total
          </div>
          <div class="col-md-12 p-right-0 p-left-0">
            <p class="bold">
              {{ currency.currency_symbol
              }}{{
                bookingPaymentSummaryData.total_with_tip_and_surcharge.toFixed(
                  2
                )
              }}
            </p>
          </div>
        </div>

        <div class="row" @click="toggleCollapse">
          <div class="col-md-4 p-right-0 p-left-0 border-style">
            <div class="col-md-12 labels-font font-family-Roboto">Deposit</div>
            <div class="col-md-12">
              <p class="bold">
                <span
                  :id="`vue_deposit_amount_view_${get_invoice_num_or_merged_invoice_num}`"
                  @click="
                    show_inputs(
                      'vue_deposit_amount',
                      get_invoice_num_or_merged_invoice_num
                    )
                  "
                >
                  {{ currency.currency_symbol }}
                  <label>{{
                    bookingPaymentSummaryData.total_deposit
                      ? bookingPaymentSummaryData.total_deposit.toFixed(2)
                      : 0
                  }}</label>
                </span>

                <span
                  :id="`vue_deposit_amount_show_action_btn_${get_invoice_num_or_merged_invoice_num}`"
                >
                  <a
                    @click="
                      show_inputs(
                        'vue_deposit_amount',
                        get_invoice_num_or_merged_invoice_num
                      )
                    "
                    class="icon-position"
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z"
                        fill="#2E4051"
                      />
                    </svg>
                  </a>
                </span>

                <span
                  :class="{
                    'float-right status-label labels-font font-family-Roboto position-status': true,
                    [depositIsPaidColorClass]: depositIsPaidColorClass,
                  }"
                >
                  {{ depositIsPaid }}
                </span>
              </p>

              <div
                :id="`vue_deposit_amount_input_section_${get_invoice_num_or_merged_invoice_num}`"
                class="hidden m-top-30"
              >
                <input
                  type="number"
                  step="0.01"
                  class="text-input width-100px"
                  :value="bookingPaymentSummaryData.total_deposit"
                  :id="`vue_deposit_amount_input_${get_invoice_num_or_merged_invoice_num}`"
                />
                <button
                  class="btn save-btn btns-change-data"
                  @click="saveDepositAmount(bookingId)"
                >
                  <i class="fa fa-check"></i>
                </button>
                <button
                  @click="
                    hide_inputs(
                      `vue_deposit_amount`,
                      get_invoice_num_or_merged_invoice_num
                    )
                  "
                  class="btn cancel-btn btns-change-data"
                >
                  <i class="fa fa-remove"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-2 p-right-0 p-left-0 border-style height-50">
            <div class="col-md-12 labels-font font-family-Roboto">Paid</div>
            <div class="col-md-12">
              {{ currency.currency_symbol }}{{ totalPaid.toFixed(2) }}
            </div>
          </div>
          <div class="col-md-6 p-right-0 p-left-0">
            <div class="col-md-12 labels-font font-family-Roboto">Balance</div>
            <div class="col-md-12">
              {{ currency.currency_symbol }}{{ totalBalance.toFixed(2) }}

              <span
                @click="Set_invoice_Due_Date(bookingId)"
                data-toggle="modal"
                data-target="#popupi"
                class="float-right status-label orange-color labels-font font-family-Roboto position-status"
                style="cursor: pointer"
              >
                {{ bookingInvoiceData.due_date_days_message }}
              </span>
            </div>
          </div>
        </div>

        <div
          v-if="itemType != 'estimate'"
          :class="{ collapsed: isCollapsed, 'p-top-20': true }"
        >
          <div class="row paymentDetail">
            <payment-row
              v-if="
                bookingInvoice.id == paymentDetail.invoice_id ||
                bookingInvoice.parent_id == null
              "
              v-for="(paymentDetail, index) in paymentDetails"
              :logged-user="loggedUser"
              :can-see-customer="canSeeCustomer"
              :key="paymentDetail.id"
              :index="index"
              :length="paymentDetails.length"
              :payment-detail="paymentDetail"
              :booking-invoice="bookingInvoiceData"
              :calculate-prices-method="calculatePrices"
              :get-payments-method="getPayments"
              @delete-payment="deletePayment(index)"
              :currency="currency"
            ></payment-row>
          </div>
        </div>
      </div>
    </div>
    <payment-invoice-popup
      :can-see-customer="canSeeCustomer"
      :booking-invoice-data="bookingInvoiceData"
      :booking-payment-summary-data="bookingPaymentSummaryData"
      :show-payment-modal-earning-data="showPaymentModalEarningData"
      :payment-details="paymentDetails"
      :status-color="statusColor"
      @modalOpened="modalOpened"
      :item-type="itemType"
      :get-summary-and-invoice="getSummaryAndInvoice"
      :booking-nums="bookingNums"
      :logged-user="loggedUser"
      :currency="currency"
      :get-payments-method="getPayments"
      :company-has-default-payment-gateway="companyHasDefaultPaymentGateway"
      :hasRecurring="hasRecurring"
      :view-page="viewPage"
      :handle-invocie-popup-changed="handleInvoiceTypeChange"
      :handle-status-color-changed="handleStatusColorTypeChange"
    >
    </payment-invoice-popup>
  </div>
</template>

<script>
import { EventBus } from "@/events/event-bus";
import PaymentDetailsModal from "@/modules/Payment/components/PaymentDetailsModal.vue";
import PaymentActionsDropdown from "@/modules/Payment/components/partial/PaymentActionsDropdown.vue";
import PaymentRow from "./PaymentRow.vue";
import { getPaymentsDetails } from "@/modules/Payment/api/index.js";
import { iSMobileDevice } from "@/events/sharedMethods";

import _ from "lodash";
import CustomerDropdown from "@/modules/Customer/components/CustomerDropdown.vue";

const EDIT_PAYMENT_LINK = "payment/edit";
export default {
  name: "Payment",
  props: {
    itemType: null,
    canSeeCustomer: null,
    showPaymentModalEarning: false,
    bookingPaymentSummary: {
      type: Object,
      required: true,
    },
    bookingInvoice: {
      required: true,
    },
    loggedUser: {
      required: true,
    },
    currency: {
      default() {
        return {
          currency_acronym: "AUD",
          currency_fontAwsome: "fa fa-dollar",
          currency_id: 51,
          currency_name: "Australian dollar",
          currency_symbol: "$",
          currency_unicode: "f155",
          recognized_in_pdf: 1,
        };
      },
    },
    bookingNums: {},
    hasRecurring: false,
    companyHasDefaultPaymentGateway: true,
    viewPage: false,
    showViewInvoicePopup: 0,
  },
  components: {
    CustomerDropdown,
    PaymentRow,
    PaymentDetailsModal,
    PaymentActionsDropdown,
  },
  data() {
    return {
      isCollapsed: true,
      customer: [],
      contactData: [],
      iSMobileDeviceData: iSMobileDevice(),
      showPaymentModalEarningData: this.showPaymentModalEarning,
      paymentDetails: [],
      applyDiscountAndCloseInvoice: 0,
      bookingBalanceDue: null,
      getSummaryAndInvoice: 0,
      openInvoicePopup: false,
      bookingPaymentSummaryData: this.bookingPaymentSummary,
      bookingInvoiceData: this.bookingInvoice,
      bookingId: (this.bookingInvoiceData || {}).booking_id
        ? (this.bookingInvoiceData || {}).booking_id
        : (this.bookingInvoice || {}).booking_id
        ? (this.bookingInvoice || {}).booking_id
        : null,
      MergedInvoiceId: (this.bookingInvoiceData || {}).merged_invoice_id
        ? (this.bookingInvoiceData || {}).merged_invoice_id
        : (this.bookingInvoice || {}).merged_invoice_id
        ? (this.bookingInvoice || {}).merged_invoice_id
        : null,
      statusColor:
        this.bookingInvoiceData && this.bookingInvoiceData.style_color
          ? "background-color:" + this.bookingInvoiceData.style_color
          : (this.bookingInvoice || {}).style_color
          ? "background-color:" + (this.bookingInvoice || {}).style_color
          : "background-color:#F44336",
    };
  },
  computed: {
    color() {
      return this.statusColor;
    },
    get_invoice_num_or_merged_invoice_num() {
      if (this.MergedInvoiceId) {
        return this.bookingInvoiceData.merged_invoice_num;
      } else {
        return this.bookingInvoiceData.invoice_num;
      }
    },
    depositIsPaid() {
      return this.totalDepositPaid ? "Paid" : "Not paid";
    },
    totalPaid() {
      let total_paid_amount = 0;
      if (
        this.bookingPaymentSummaryData
          .total_paid_amount_with_tip_and_surcharge &&
        !this.bookingInvoiceData.parent_id
      ) {
        total_paid_amount =
          this.bookingPaymentSummaryData
            .total_paid_amount_with_tip_and_surcharge;
      }
      if (
        this.bookingInvoiceData.paid_amount &&
        this.bookingInvoiceData.parent_id
      ) {
        total_paid_amount = this.bookingInvoiceData.paid_amount;
      }

      if (
        this.bookingInvoiceData.paid_amount == null &&
        this.bookingInvoiceData.parent_id
      ) {
        total_paid_amount = 0;
      }
      return total_paid_amount;
      // return this.bookingPaymentSummaryData.paid_amount;
    },
    totalTip() {
      return this.bookingPaymentSummaryData
        ? (this.bookingPaymentSummaryData.tip || {}).total_tip
        : 0;
    },
    totalBalance() {
      if (this.bookingInvoiceData.parent_id) {
        let paid_amount = this.bookingInvoiceData.paid_amount
          ? this.bookingInvoiceData.paid_amount
          : 0;
        return this.bookingPaymentSummaryData.total - paid_amount;
      } else {
        return (
          this.bookingPaymentSummaryData.total_with_tip_and_surcharge -
          this.totalPaid
        );
      }
    },
    totalDepositPaid() {
      return (
        this.bookingPaymentSummaryData.paid_amount >=
        this.bookingPaymentSummaryData.total_deposit
      );
    },
    depositIsPaidColorClass() {
      return this.totalDepositPaid ? "green-color" : "red-color";
    },
  },
  methods: {
    modalOpened(value) {
      this.$emit("modalOpened", value);
    },
    Set_invoice_Due_Date(booking_id = 0) {
      window.popupi(
        "Set invoice Due Date",
        `/invoices/set-due-date/${booking_id}?booking_id=${booking_id}`
      );
    },

    addEventListeners() {
      // When a service has been selected from services dropdown
      EventBus.$on("onDueDateChanged", (value) => {
        this.bookingInvoiceData.due_date_days_message = value;
      });
      // When a service has been selected from services dropdown
      EventBus.$on("labelsAdded", (value, entityId) => {
        if (entityId && this.bookingInvoiceData.id == entityId) {
          this.bookingInvoiceData.invoice_labels = [];
          this.bookingInvoiceData.invoice_labels.push(value);
        }
      });
      EventBus.$on("paymentRefunded", (value) => {
        $("#popupi").modal("hide");
        this.getPayments();
        return;
      });
      EventBus.$on("updateAllPaymentBox", (value) => {
        this.getSummaryAndInvoice = 1;
        if (value && value.bookingId) {
          this.bookingId = value.bookingId;
        }
        if (value && value.openInvoicePopup) {
          this.openInvoicePopup = true;
        }
        this.getPayments();
        return;
      });
      EventBus.$on("onDepositUpdated", (value) => {
        this.bookingPaymentSummaryData.total_deposit = Number(value);
      });
    },
    calculatePrices() {
      let paid = 0;
      let tip = 0;
      let approvedPayemnts = this.paymentDetails.filter(
        (payment) =>
          payment.is_approved && !payment.is_rejected && !payment.is_deleted
      );
      for (let approvedPayemnt of approvedPayemnts) {
        if (approvedPayemnt.type === "refund") {
          paid -= +approvedPayemnt.total_paid;
          tip -= +approvedPayemnt.tip;
        } else {
          paid += +approvedPayemnt.total_paid;
          tip += +approvedPayemnt.tip;
        }
      }
      this.bookingPaymentSummaryData.paid_amount = paid;
      this.bookingPaymentSummaryData.tip.total_tip = tip;
    },
    deletePayment(index) {
      this.paymentDetails.splice(index, 1);
      this.getPayments();
    },
    handleInvoiceTypeChange(newType) {
      this.bookingInvoiceData.invoice_type = `${newType}`;
    },
    handleStatusColorTypeChange(newColor) {
      this.statusColor = newColor;
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;

      $(this.$refs.toggleIcon).toggleClass("rotate-180");
    },
    show_inputs(id = "", invoice_num = "") {
      if (invoice_num) {
        $("#" + id + "_view_" + invoice_num).addClass("hidden");
        $("#" + id + "_show_action_btn_" + invoice_num).addClass("hidden");
        $("#" + id + "_input_section_" + invoice_num).removeClass("hidden");
        $("#" + id + "_input").val($("#" + id + "_view label").html());
      } else {
        $("#" + id + "_view").addClass("hidden");
        $("#" + id + "_show_action_btn").addClass("hidden");
        $("#" + id + "_input_section").removeClass("hidden");
        $("#" + id + "_input").val($("#" + id + "_view label").html());
      }
    },
    hide_inputs(id = "", invoice_num = "") {
      if (invoice_num) {
        $("#" + id + "_view_" + invoice_num).removeClass("hidden");
        $("#" + id + "_show_action_btn_" + invoice_num).removeClass("hidden");
        $("#" + id + "_input_section_" + invoice_num).addClass("hidden");
      } else {
        $("#" + id + "_view").removeClass("hidden");
        $("#" + id + "_show_action_btn").removeClass("hidden");
        $("#" + id + "_input_section").addClass("hidden");
      }
    },
    saveDepositAmount(booking_id = 0) {
      let vm = this;
      var target_id =
        "vue_deposit_amount_input_" + vm.get_invoice_num_or_merged_invoice_num;
      let depositAmount = parseFloat(document.getElementById(target_id).value);
      let url = `/set-booking-deposit-amount/${booking_id}`;
      let formDataInputs = new FormData();
      formDataInputs.append("deposit", depositAmount);
      window.axios
        .post(url, formDataInputs, {
          responseType: "json", // default
        })
        .then(function (response) {
          vm.bookingPaymentSummaryData.total_deposit = depositAmount;
          vm.hide_inputs(
            "vue_deposit_amount",
            vm.get_invoice_num_or_merged_invoice_num
          );
        });
    },
    saveInvoiceNum(invoice_id = 0) {
      if (invoice_id) {
        let invoiceNum = $("#vue_invoice_num_input_" + invoice_id).val();
        let saveURL = `/invoice/edit-invoice-number/${invoice_id}`;
        let validateURL = `/invoice`;
        let vm = this;
        let formDataInputs = new FormData();
        formDataInputs.append("invoice_number", invoiceNum);

        window.axios
          .post(validateURL, formDataInputs, {
            responseType: "json", // default
          })
          .then(function (response) {
            console.log(response);
            if (response.data.is_duplicate) {
              $.notify(
                `This invoice number already exists in the system, you can not have duplicate invoice numbers.
                    Please enter a different invoice number.`,
                "error"
              );
            } else {
              window.axios
                .post(saveURL, formDataInputs, {
                  responseType: "json", // default
                })
                .then(function (response) {
                  console.log(response);
                  $(
                    "#vue_invoice_num_view_" +
                      vm.get_invoice_num_or_merged_invoice_num +
                      " label"
                  ).html(invoiceNum);
                  vm.hide_inputs(
                    "vue_invoice_num",
                    vm.get_invoice_num_or_merged_invoice_num
                  );
                  $.notify(
                    `Your invoice has been updated to ` + invoiceNum,
                    "success"
                  );
                });
            }
          });
      }
    },
    Invoice_Preview_Data(id = 0, merged_invoice_id = 0) {
      if (merged_invoice_id === null) {
        merged_invoice_id = 0;
      }

      window.popupi(
        "Invoice Preview",
        `/invoice/preview/${id}?booking_id=${id}&merged_invoice_id=${merged_invoice_id}`
      );
    },
    Invoice_Add_Label() {
      window.popupi(
        "Invoice label",
        `/invoice/label/select-label/${this.bookingInvoiceData.id}`
      );
    },

    getPayments() {
      if (this.bookingId != null) {
        // Always fetch invoice data if we don't have it yet or if explicitly requested
        // This prevents the invoice from disappearing after save changes
        // Check explicit request FIRST, then check if data is missing
        const needsInvoiceData = this.getSummaryAndInvoice === 1 || !this.bookingInvoiceData || !this.bookingInvoiceData.id;

        getPaymentsDetails({
          booking_id: this.bookingId,
          merged_invoice_id: this.MergedInvoiceId,
          get_summary_and_invoice: needsInvoiceData ? 1 : 0,
        }).then((response) => {
          if (response.data.type == "success") {
            this.paymentDetails = response.data.paymentDetails;
            this.applyDiscountAndCloseInvoice =
              response.data.apply_discount_and_close_invoice;
            if (response.data.bookingPaymentSummary) {
              this.bookingPaymentSummaryData =
                response.data.bookingPaymentSummary;
            }
            if (response.data.bookingInvoice) {
              this.bookingInvoiceData = response.data.bookingInvoice;
              EventBus.$emit(
                "convertBookingToInvoiceEvent",
                this.bookingInvoiceData
              );
            }
            this.getSummaryAndInvoice = 0;
            this.calculatePrices();
            if (this.openInvoicePopup) {
              this.$nextTick(() => {
                $(`#invoice-popup${this.bookingId}`).modal("show");
                this.openInvoicePopup = false;
              });
            }
          }
        });
      }
    },
    getWidth() {
      let xWidth = null;
      if (window.screen != null) xWidth = window.screen.availWidth;

      if (window.innerWidth != null) xWidth = window.innerWidth;

      if (document.body != null) xWidth = document.body.clientWidth;

      return xWidth;
    },
  },
  mounted() {
    if (this.bookingInvoiceData.merged_bookings) {
      this.bookingInvoiceData.merged_bookings.forEach((bok) => {
        this.$set(bok, "modalIsCollapsed", true); // Default to true or false as per your requirement
      });
    }
    if (this.bookingInvoiceData.booking_customer_share) {
      this.bookingPaymentSummaryData.total =
        this.bookingInvoiceData.booking_customer_share;
    }
    // if (this.bookingInvoiceData.paid_amount ){
    //     this.bookingPaymentSummaryData.paid_amount =this.bookingInvoiceData.paid_amount;
    // }
    this.addEventListeners();
    this.getPayments();
    if (this.showViewInvoicePopup) {
      $(`.invoice-popup-modal${this.showViewInvoicePopup}`).modal("show");
    }
  },
};
</script>

<style scoped>
.data_style_filde {
  color: rgb(46, 64, 81);
  font-size: 18px;
}
.modal {
  overflow: auto !important;
}
.payment-details-container {
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #eaecee;
  margin-top: 23px;
}
.service_item_header_mobile {
  display: none;
}
.service_item_content_mobile {
  display: none;
}
.booking-title-toggle {
  padding: 3px 0px 0px 7px;
}
.booking-title-toggle::before {
  padding: 0px 7px 3px 0px;
}
.service_item_header {
  padding: 8px 0px 8px 0px;
}
.service_item {
  padding: 8px 0px 8px 0px;
  //border-bottom:  1px solid #EAECEE;
}
.service_item:last-child {
  border-bottom: 0px solid #000;
}
.booking_title {
  font-weight: 700;
  font-size: 14px;
  color: #2e4051;
}
.booking_item {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #2e4051;
}
.status-label {
  color: #ffffff !important;
  border-radius: 100px !important;
  padding: 2px 8px 4px 8px !important;
}

.border-style {
  border-right: 1px solid;
  border-color: #eaecee;
}

.labels-font {
  font-size: 14px;
  font-weight: 700;
  color: #2e4051;
}

.font-family-Roboto {
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #2e4051;
}

.collapsed {
  display: none;
}

.rotate {
  -moz-transition: all 0.5s linear;
  -webkit-transition: all 0.5s linear;
  transition: all 0.5s linear;
}

.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0.5);
  -webkit-transform: rotate(-180deg);
  -moz-transform: rotate(-180deg);
  -ms-transform: rotate(-180deg);
  -o-transform: rotate(-180deg);
  transform: rotate(-180deg);
  display: inline-block;
}

.position-status {
  position: relative;
  bottom: 2px;
}
.position-status-invoice-modal {
  position: relative;
  bottom: 4px;
}
.p-bottom-desktop-8 {
  padding-bottom: 8px;
}

.pair_btn_new_uniq .create-btn {
  border: none !important;
}

.cursor-pointer {
  cursor: pointer;
}

.icon-position {
  position: relative;
  top: 4px;
  left: 2px;
}

.btns-change-data {
  padding: 3px 6px !important;
  position: relative;
  bottom: 2px;
}

.cancel-btn {
  padding: 3px 7px !important;
}

.width-100px {
  width: 100px;
}

.modal-header.new-design {
  border-bottom: unset;
}

.has-error .form-control {
  border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
  font-family: "Roboto", serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #2e4051;
  display: inline;
}

.modal-footer.new-design {
  border-top: unset;
}

.close-icon {
  float: right;
}

.clickable {
  cursor: pointer;
}

.white-space-nowrap {
  white-space: nowrap;
}

.line-height-36 {
  line-height: 36px;
}

.left-12 {
  left: 12px;
}

.content-service {
  background-color: #f9f9fa;
  border-radius: 12px;
  padding: 8px;
}
.background-color-gray {
  background-color: #f9f9fa;
  border-radius: 12px;
}
.p-all-20 {
  padding: 20px;
}
@media (max-width: 768px) {
  .mobile-p-left-4 {
    padding-left: 4px;
  }

  .mobile-position {
    position: relative;
    bottom: 95px;
    left: 95px;
  }
  .service_item {
    display: none;
  }
  .service_item_header {
    display: none;
  }

  .mobile-right-8 {
    right: -60px !important;
  }
  .service_item_header_mobile {
    display: block;
  }
  .service_item_content_mobile {
    display: block;
    padding: 10px 0px 0px;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .mobile-position {
    left: 215px;
  }
  .service_item {
    display: none;
  }
  .service_item_header {
    display: none;
  }
  .threedots-p-left {
    padding-left: 30px;
  }
  .service_item_header_mobile {
    display: block;
  }
  .service_item_content_mobile {
    display: block;
    padding: 10px 0px 0px;
  }
  sup {
    font-size: smaller;
    vertical-align: super;
  }
}
</style>
<style>
.blue-color {
  background-color: #008cfa !important;
}

.green-color {
  background-color: #37bd5d !important;
}

.orange-color {
  background-color: #ff932f !important;
}
.red-color {
  background-color: #f44336 !important;
}
.gray-color {
  background-color: #979fa8 !important;
}
</style>
